var _clipPath, _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLaptopHomepage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 100,
    width: 152.004,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-laptop-homepage_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-5.343h152v-100H0z",
    transform: "translate(0 105.343)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.224 83.173l2.718 9.79 4.243 4.487h136.526l5.027-6.119-.385-8.158z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-laptop-homepage_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.291 83.726H11.711V6.602a4.849 4.849 0 014.912-4.784h118.758a4.849 4.849 0 014.91 4.784zm.068 14.454H11.642a9.7 9.7 0 01-9.823-9.57v-4.884h148.364v4.884a9.7 9.7 0 01-9.822 9.57z",
    fill: "none",
    stroke: "#011e41",
    strokeWidth: 3.834
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.053 15.095a3.606 3.606 0 01-3.607 3.607 3.606 3.606 0 01-3.608-3.607 3.606 3.606 0 013.608-3.607 3.606 3.606 0 013.607 3.607",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.053 15.095a3.606 3.606 0 01-3.607 3.607 3.606 3.606 0 01-3.608-3.607 3.606 3.606 0 013.608-3.607 3.606 3.606 0 013.607 3.607z",
    fill: "none",
    stroke: "#011e41",
    strokeWidth: 1.089
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.805 25.749a5.642 5.642 0 015.642-5.643 5.642 5.642 0 015.642 5.643",
    fill: "#011e41",
    stroke: "#011e41",
    strokeWidth: 1.089
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.053 39.083a3.606 3.606 0 01-3.607 3.607 3.606 3.606 0 01-3.608-3.607 3.606 3.606 0 013.608-3.607 3.606 3.606 0 013.607 3.607",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.053 39.083a3.606 3.606 0 01-3.607 3.607 3.606 3.606 0 01-3.608-3.607 3.606 3.606 0 013.608-3.607 3.606 3.606 0 013.607 3.607z",
    fill: "none",
    stroke: "#011e41",
    strokeWidth: 1.089
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.805 49.736a5.642 5.642 0 015.642-5.643 5.642 5.642 0 015.642 5.643",
    fill: "#011e41",
    stroke: "#011e41",
    strokeWidth: 1.089
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.053 63.07a3.606 3.606 0 01-3.607 3.607 3.606 3.606 0 01-3.608-3.607 3.606 3.606 0 013.608-3.607 3.606 3.606 0 013.607 3.607",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#011e41",
    strokeWidth: 1.089
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.053 63.07a3.606 3.606 0 01-3.607 3.607 3.606 3.606 0 01-3.608-3.607 3.606 3.606 0 013.608-3.607 3.606 3.606 0 013.607 3.607z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.805 73.724a5.642 5.642 0 015.642-5.643 5.642 5.642 0 015.642 5.643",
    fill: "#011e41"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.394 22.448h87.368M36.394 64.981h76.691M36.343 43.736h61.06",
    fill: "none",
    stroke: "#011e41",
    strokeWidth: 3.834
  })));
}
export default SvgIconLaptopHomepage;